import {Component, effect, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, RouterModule, RouterOutlet} from "@angular/router";
import {CommonModule, NgIf} from "@angular/common";
import {WhiteLabelService} from "@cybfed/core/services/web-site/white-label-service";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {GameService} from "@cybfed/core/services/game.service";
import {AdminSidebarComponent} from "@white-label/components/admin-sidebar/admin-sidebar.component";
import {PublisherService} from "@cybfed/core/services/publisher-service";
import {
    DefaultHeaderComponent
} from "@white-label/components/page-builder/components/headers/default/default-header.component";
import {
    DefaultFooterComponent
} from "@white-label/components/page-builder/components/footers/dedault/default-footer.component";
import {FeedBackComponent} from "@cybfed/shared/components/feed-back/feed-back.component";
import * as defaultTheme from "../../components/page-builder/theme-settings-form/themes/default_theme.json"
import {ThemeService} from "@white-label/components/page-builder/theme-settings-form/themes/theme.service";

@Component({
    selector: 'app-admin',
    standalone: true,
    imports: [
        RouterOutlet,
        CommonModule,
        RouterModule,
        TranslateModule,
        AdminSidebarComponent,
        DefaultHeaderComponent,
        DefaultFooterComponent,
        FeedBackComponent
    ],
    providers: [
        GameService,
        PopupHelperService,
        WhiteLabelService,
        PublisherService
    ],
    templateUrl: './admin.component.html'
})
export class AdminComponent implements OnInit{

    public whiteLabelId: any
    public whiteLabel: any

    constructor(private whiteLabelService: WhiteLabelService,
                public mainStoreService: MainStoreService,
                private publisherService: PublisherService,
                private route: ActivatedRoute,
                private themeService: ThemeService) {
        this.themeService.applyTheme(defaultTheme[':root']);
        this.whiteLabelId = this.route.snapshot.paramMap.get('whiteLabelId');
        if (!this.whiteLabelId) {
            this.whiteLabel = this.mainStoreService.whiteLabel
            this.whiteLabelId =this.whiteLabel._id;
            effect(() => {
                this.whiteLabel = this.mainStoreService.adminWhiteLabel
                if (this.whiteLabel) {
                    this.whiteLabelId =this.whiteLabel._id;
                    this.getPublisher(this.whiteLabel.publisherId)
                }
            });
        }
    }
    ngOnInit() {
        this.whiteLabelService.getAllSettingsById(this.whiteLabelId).subscribe((data: any) => {
            if(!data.hasError){
                this.mainStoreService.adminWhiteLabel = data.data.whiteLabel;
            }
        })

    }

    private getPublisher(publisherId) {
        this.publisherService.getPublisherInfo(publisherId).subscribe((data: any) => {
            if(!data.hasError){
                this.mainStoreService.publisher = data.data.publisher;
            }
        })
    }
}
